import styleInject from 'style-inject';

var css_248z = ".cf-error-message {\n  margin: 24px;\n  font-size: var(--exp-builder-font-size-m);\n  font-family: var(--exp-builder-font-stack-primary);\n  color: var(--exp-builder-red800);\n  padding: 16px;\n  background-color: var(--exp-builder-red200);\n}\n\n.cf-error-message .title {\n  margin-top: 0;\n  font-size: var(--exp-builder-font-size-l);\n}\n\n.cf-error-message .more-details {\n  cursor: pointer;\n  color: var(--exp-builder-blue700);\n}\n";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=ErrorBoundary.css.js.map
